import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "header-left" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 0,
  class: "header-center"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "header-center"
}
const _hoisted_9 = { class: "header-slogan text-primary" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "header-right" }
const _hoisted_12 = {
  key: 0,
  class: "header-links"
}
const _hoisted_13 = { class: "header-toolbar" }
const _hoisted_14 = ["title", "onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["title", "onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon-compare",
  id: "header-icon-compare"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path3" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path4" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path5" })
], -1)
const _hoisted_19 = ["title", "onClick"]
const _hoisted_20 = ["href", "onClick"]
const _hoisted_21 = {
  key: 1,
  class: "header-buttons"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_25 = {
  class: "menu-wrap",
  ref: "menuWrap"
}
const _hoisted_26 = {
  key: 0,
  class: "user"
}
const _hoisted_27 = { class: "user__photo" }
const _hoisted_28 = { class: "user__info" }
const _hoisted_29 = { class: "user__name" }
const _hoisted_30 = {
  key: 0,
  class: "user__logo"
}
const _hoisted_31 = { key: 2 }
const _hoisted_32 = ["href", "onClick"]
const _hoisted_33 = ["href", "onClick"]
const _hoisted_34 = ["href", "onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "icon-stats" }, null, -1)
const _hoisted_36 = ["href", "onClick"]
const _hoisted_37 = ["href", "onClick"]
const _hoisted_38 = ["href", "onClick"]
const _hoisted_39 = ["href", "onClick"]
const _hoisted_40 = ["href", "onClick"]
const _hoisted_41 = { key: 3 }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = ["href", "onClick"]
const _hoisted_44 = {
  key: 0,
  class: "badge"
}
const _hoisted_45 = ["href", "onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "icon-compare" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path3" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path4" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path5" })
], -1)
const _hoisted_47 = {
  key: 0,
  class: "badge"
}
const _hoisted_48 = ["href", "onClick"]
const _hoisted_49 = ["href", "onClick"]
const _hoisted_50 = ["href"]
const _hoisted_51 = {
  class: "icon-cookies",
  href: "?cookieconsent=1"
}
const _hoisted_52 = { class: "menu-footer" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", null, "All rights reserved", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_ShareSiteBox = _resolveComponent("ShareSiteBox")!
  const _component_easy_login_form = _resolveComponent("easy-login-form")!

  return (_openBlock(), _createElementBlock("header", {
    id: "header",
    onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.headerMenuMouseLeave()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        href: _ctx.baseUrl,
        id: "header-logo"
      }, [
        _createElementVNode("img", {
          src: _ctx.logoUrl,
          alt: _ctx.domain + ' logo'
        }, null, 8, _hoisted_3)
      ], 8, _hoisted_2)
    ]),
    (_ctx.showDeveloperHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("a", {
            class: "header-slogan header-slogan--developer",
            href: _ctx.developerUrl
          }, [
            _createElementVNode("img", { src: _ctx.developerIconUrl }, null, 8, _hoisted_6),
            _createElementVNode("img", { src: _ctx.developerImageUrl }, null, 8, _hoisted_7)
          ], 8, _hoisted_5)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSlogans && !_ctx.showDeveloperHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.sloganUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.sloganUrl
                }, null, 8, _hoisted_10))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.$slots.menu)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _renderSlot(_ctx.$slots, "menu")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        (!_ctx.isEstateAgencyMode)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'AdHistory' },
              custom: ""
            }, {
              default: _withCtx(({ navigate, isExactActive }) => [
                _createElementVNode("span", {
                  id: "header-history",
                  title: _ctx.$t('TheHeader.history-tooltip'),
                  class: _normalizeClass(["header-toolbar__item", { 'is-active': isExactActive }]),
                  onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive, _ctx.$t('history-not-logged-in')))
                }, _hoisted_16, 10, _hoisted_14)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.isEstateAgencyMode)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: { name: 'AdCompare' },
              custom: ""
            }, {
              default: _withCtx(({ navigate, isExactActive }) => [
                _createElementVNode("span", {
                  id: "header-compare",
                  title: _ctx.$t('TheHeader.compare-tooltip'),
                  class: _normalizeClass(["header-toolbar__item", { 'is-active': _ctx.compareCount }]),
                  onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive, _ctx.$t('compare-not-logged-in')))
                }, [
                  _hoisted_18,
                  _createElementVNode("span", null, _toDisplayString(_ctx.compareCount), 1)
                ], 10, _hoisted_17)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.isEstateAgencyMode)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              to: { name: 'AdUserFavorite' },
              custom: ""
            }, {
              default: _withCtx(({ navigate, isExactActive }) => [
                _createElementVNode("span", {
                  id: "header-favorite",
                  title: _ctx.$t('TheHeader.favorite-tooltip'),
                  class: _normalizeClass(["header-toolbar__item", { 'is-active': _ctx.favoriteCount }]),
                  onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive, _ctx.$t('favorite-not-logged-in')))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.favoriteCount), 1)
                ], 10, _hoisted_19)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          id: "header-language",
          class: "header-toolbar__item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage(_ctx.targetLanguageId)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.targetLanguageId), 1)
        ]),
        (!_ctx.isEstateAgencyMode)
          ? (_openBlock(), _createElementBlock("span", {
              key: 3,
              id: "header-account",
              class: _normalizeClass(["header-toolbar__item", { 'is-active': _ctx.isLoggedIn, 'is-warning': _ctx.user && !_ctx.user.isEmailConfirmed }])
            }, [
              (_ctx.isLoggedIn)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: 'AdUserList' },
                    custom: ""
                  }, {
                    default: _withCtx(({ href, navigate, isExactActive }) => [
                      _createElementVNode("a", {
                        href: href,
                        onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive))
                      }, _toDisplayString(_ctx.user.fullName), 9, _hoisted_20)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.isLoggedIn)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLoginModal()))
                  }, _toDisplayString(_ctx.$t('TheHeader.account')), 1))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isEstateAgencyMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createVNode(_component_router_link, {
              to: { name: 'AdFormCreate' },
              tag: "button",
              class: "button button--primary",
              id: "button-add-estate"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('TheHeader.insert-ad')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("nav", {
        id: "header-menu",
        onMouseover: _cache[6] || (_cache[6] = ($event: any) => (_ctx.headerMenuMouseOver()))
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isMenuOpened) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.isMenuOpened]
        ]),
        _hoisted_22,
        _hoisted_23,
        _hoisted_24,
        _createElementVNode("div", {
          class: _normalizeClass([{ hidden: !_ctx.isMobile }, "menu-overlay"]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeMenu()))
        }, null, 2),
        _createElementVNode("div", _hoisted_25, [
          (_ctx.isLoggedIn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_ResizableImage, {
                    url: _ctx.user.photoRelativeUrl,
                    placeholder: "img/no-photo-user.png",
                    width: 135,
                    height: 135,
                    alt: _ctx.user.fullName
                  }, null, 8, ["url", "alt"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.user.fullName), 1),
                  (_ctx.user.isEstateAgent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createVNode(_component_ResizableImage, {
                          classes: "estate-agency-logo",
                          url: _ctx.user.logoRelativeUrl,
                          placeholder: "img/no-logo-agency.png",
                          width: 240,
                          height: 135,
                          alt: "agency"
                        }, null, 8, ["url"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.$slots.menu)
            ? _renderSlot(_ctx.$slots, "menu", { key: 1 })
            : _createCommentVNode("", true),
          (_ctx.isLoggedIn)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_31, [
                _createVNode(_component_router_link, {
                  to: { name: 'UserProfile' },
                  custom: ""
                }, {
                  default: _withCtx(({ href, navigate, isExactActive }) => [
                    _createElementVNode("li", {
                      class: _normalizeClass({ 'is-active': isExactActive })
                    }, [
                      _createElementVNode("a", {
                        class: "icon-user",
                        href: href,
                        onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive))
                      }, _toDisplayString(_ctx.$t('menu.profile')), 9, _hoisted_32)
                    ], 2)
                  ]),
                  _: 1
                }),
                (_ctx.user.isAdmin)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: { name: 'EstateAgencyProfile' },
                      custom: ""
                    }, {
                      default: _withCtx(({ href, navigate, isExactActive }) => [
                        _createElementVNode("li", {
                          class: _normalizeClass({ 'is-active': isExactActive })
                        }, [
                          _createElementVNode("a", {
                            class: "icon-user",
                            href: href,
                            onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive))
                          }, _toDisplayString(_ctx.$t('menu.profile-agency')), 9, _hoisted_33)
                        ], 2)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.user.isAdmin)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: { name: 'AdStatistics' },
                      custom: ""
                    }, {
                      default: _withCtx(({ href, navigate, isExactActive }) => [
                        _createElementVNode("li", {
                          class: _normalizeClass({ 'is-active': isExactActive })
                        }, [
                          _createElementVNode("a", {
                            href: href,
                            onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive))
                          }, [
                            _hoisted_35,
                            _createTextVNode(_toDisplayString(_ctx.$t('menu.statistics')), 1)
                          ], 8, _hoisted_34)
                        ], 2)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, {
                  to: { name: 'AdUserList' },
                  custom: ""
                }, {
                  default: _withCtx(({ href, navigate, isExactActive }) => [
                    _createElementVNode("li", {
                      class: _normalizeClass({ 'is-active': isExactActive })
                    }, [
                      _createElementVNode("a", {
                        class: "icon-category",
                        href: href,
                        onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive))
                      }, _toDisplayString(_ctx.$t('menu.my-ads')), 9, _hoisted_36)
                    ], 2)
                  ]),
                  _: 1
                }),
                (_ctx.user.isAdmin)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      to: { name: 'AdUserAgencyList' },
                      custom: ""
                    }, {
                      default: _withCtx(({ href, navigate, isExactActive }) => [
                        _createElementVNode("li", {
                          class: _normalizeClass({ 'is-active': isExactActive })
                        }, [
                          _createElementVNode("a", {
                            class: "icon-category",
                            href: href,
                            onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive))
                          }, _toDisplayString(_ctx.$t('menu.agency-ads')), 9, _hoisted_37)
                        ], 2)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.user.isEstateAgent)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 3,
                      to: { name: 'AdDeveloperProjectList' },
                      custom: ""
                    }, {
                      default: _withCtx(({ href, navigate, isExactActive }) => [
                        _createElementVNode("li", {
                          class: _normalizeClass({ 'is-active': isExactActive })
                        }, [
                          _createElementVNode("a", {
                            class: "icon-crane",
                            href: href,
                            onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive))
                          }, _toDisplayString(_ctx.$t('menu.developer-projects')), 9, _hoisted_38)
                        ], 2)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, {
                  to: { name: 'UserSettings' },
                  custom: ""
                }, {
                  default: _withCtx(({ href, navigate, isExactActive }) => [
                    _createElementVNode("li", {
                      class: _normalizeClass({ 'is-active': isExactActive })
                    }, [
                      _createElementVNode("a", {
                        class: "icon-filter",
                        href: href,
                        onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive))
                      }, _toDisplayString(_ctx.$t('menu.settings')), 9, _hoisted_39)
                    ], 2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'Feedback' },
                  custom: ""
                }, {
                  default: _withCtx(({ href, navigate, isExactActive }) => [
                    _createElementVNode("li", {
                      class: _normalizeClass({ 'is-active': isExactActive })
                    }, [
                      _createElementVNode("a", {
                        class: "icon-feedback",
                        href: href,
                        onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive))
                      }, _toDisplayString(_ctx.$t('menu.feedback')), 9, _hoisted_40)
                    ], 2)
                  ]),
                  _: 1
                }),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "icon-logout",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                  }, _toDisplayString(_ctx.$t('menu.logout')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isEstateAgencyMode)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_41, [
                (!_ctx.isLoggedIn)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                      _createElementVNode("a", {
                        class: "icon-user",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showLoginModal()))
                      }, _toDisplayString(_ctx.$t('menu.login')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, {
                  to: { name: 'AdUserFavorite' },
                  custom: ""
                }, {
                  default: _withCtx(({ href, navigate, isExactActive }) => [
                    _createElementVNode("li", {
                      class: _normalizeClass({ 'is-active': isExactActive })
                    }, [
                      _createElementVNode("a", {
                        class: "icon-favorite",
                        href: href,
                        onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive, _ctx.$t('favorite-not-logged-in')))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('menu.favorite')) + " ", 1),
                        (_ctx.favoriteCount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.favoriteCount), 1))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_43)
                    ], 2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'AdCompare' },
                  custom: ""
                }, {
                  default: _withCtx(({ href, navigate, isExactActive }) => [
                    _createElementVNode("li", {
                      class: _normalizeClass({ 'is-active': isExactActive })
                    }, [
                      _createElementVNode("a", {
                        href: href,
                        onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive, _ctx.$t('compare-not-logged-in')))
                      }, [
                        _hoisted_46,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('menu.compare')) + " ", 1),
                        (_ctx.compareCount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.compareCount), 1))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_45)
                    ], 2)
                  ]),
                  _: 1
                }),
                (_ctx.isLoggedIn)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: { name: 'AdFilterList' },
                      custom: ""
                    }, {
                      default: _withCtx(({ href, navigate, isExactActive }) => [
                        _createElementVNode("li", {
                          class: _normalizeClass({ 'is-active': isExactActive })
                        }, [
                          _createElementVNode("a", {
                            class: "icon-search",
                            href: href,
                            onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive))
                          }, _toDisplayString(_ctx.$t('menu.filter-list')), 9, _hoisted_48)
                        ], 2)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, {
                  to: { name: 'AdHistory' },
                  custom: ""
                }, {
                  default: _withCtx(({ href, navigate, isExactActive }) => [
                    _createElementVNode("li", {
                      class: _normalizeClass({ 'is-active': isExactActive })
                    }, [
                      _createElementVNode("a", {
                        class: "icon-history",
                        href: href,
                        onClick: ($event: any) => (_ctx.go($event, navigate, isExactActive, _ctx.$t('history-not-logged-in')))
                      }, _toDisplayString(_ctx.$t('menu.history')), 9, _hoisted_49)
                    ], 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isEstateAgencyMode)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 4,
                to: { name: 'AdFormCreate' },
                tag: "button",
                class: "button button--primary",
                id: "button-add-estate"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('TheHeader.insert-ad')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isEstateAgencyMode)
            ? (_openBlock(), _createBlock(_component_ShareSiteBox, { key: 5 }))
            : _createCommentVNode("", true),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "icon-info",
                href: _ctx.aboutUsUrl
              }, _toDisplayString(_ctx.$t('TheHeader.about-us')), 9, _hoisted_50)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_51, _toDisplayString(_ctx.$t('TheHeader.cookies')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("span", null, _toDisplayString(new Date().getFullYear()) + " © " + _toDisplayString(_ctx.domain.split('.')[0]), 1),
            _hoisted_53
          ])
        ], 512)
      ], 32)
    ]),
    (_ctx.isLoginModalVisible)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 2,
          to: "#container"
        }, [
          _createVNode(_component_easy_login_form, {
            onClose: _ctx.closeLoginModal,
            showCloseButton: true,
            alertText: _ctx.alertText
          }, null, 8, ["onClose", "alertText"])
        ]))
      : _createCommentVNode("", true)
  ], 32))
}